import { FC } from 'react'
import { getCondominiumInfos, getCondominiumDataCards } from 'lib/condominium'
import { CondominiumDetails, Tag } from 'graphql/types'
import SectionHeader from 'components/SectionHeader'
import DataCarousel from 'pages/regioes-atendidas/regiao/components/DataCarousel'
import FeatureItem from 'components/FeatureItem'
import regionStyles from 'pages/regioes-atendidas/regiao/Region.module.scss'
import styles from './Data.module.scss'

type TProps = CondominiumDetails

const Data: FC<TProps> = (condominium) => {
  const { information, tags } = condominium

  const cards = getCondominiumDataCards(condominium)
  const infos = getCondominiumInfos({
    ...information,
    tags: tags as Array<Tag>,
  })

  return (
    <div className={regionStyles.ecPageRegionSection}>
      <SectionHeader
        title={{
          value: 'Principais características',
        }}
        text="Principais informações do condomínio com base nos imóveis à venda na EmCasa"
      />
      <DataCarousel
        staticNavigation
        items={cards}
        slidesPerPage={{
          desktop: 3,
        }}
      />
      <div className={styles.ecDataInfos}>
        {infos.map((info) => (
          <FeatureItem
            testId="ecInfoItem"
            key={info?.title}
            title={info?.title}
            text={info?.text}
            value={info?.value}
            Icon={info?.Icon}
          />
        ))}
      </div>
    </div>
  )
}

export default Data
